import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import Spinner from '../../components/common/Spinner';
import AccountInfo from '../../components/blocks/AccountInfo';
import { getAdminAccountInfo, postAdminAccountInfo } from '../../store/actions/adminAccountInfo';
import EditAccountModal from '../../components/blocks/EditAccountModal/EditAccountModal';

function AccountInfoContainer(props) {
  const { getInfo } = props;
  const [open, setOpen] = useState(false);

  useEffect(() => {
    getInfo();
  }, [getInfo]);

  if (props.isLoading) {
    return <Spinner />;
  }

  return (
    <>
      <AccountInfo retailer={props.retailer} openEdit={() => setOpen(true)} />

      <EditAccountModal
        retailer={props.retailer}
        open={open}
        saveInfo={props.saveInfo}
        onClose={() => setOpen(false)}
      />
    </>
  );
}

const mapStateToProps = (state) => {
  const { data, isLoading } = state.adminAccountInfo;

  return {
    retailer: data,
    isLoading,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getInfo: () => dispatch(getAdminAccountInfo()),
  saveInfo: (data) => dispatch(postAdminAccountInfo(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AccountInfoContainer);
